import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';
import { formatDate, formatViews } from '@/utils/format';

interface Props {
  item: NewsItem;
  className?: string;
}

export default function NewsListItem({ item, className = '' }: Props) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className={`group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50/40 md:p-4 ${className}`}
    >
      <div className="h-[88px] w-[120px] flex-none overflow-hidden rounded-md bg-background-100 sm:h-[100px] sm:w-[150px]">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 靠逼娱乐资讯`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
            {item.category}
          </span>
          <span className="text-[11px] text-foreground-400">{formatDate(item.publishedAt)}</span>
        </div>
        <h3 className="mt-1.5 line-clamp-2 font-heading text-[15px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1 hidden line-clamp-1 text-xs text-foreground-500 sm:block">{item.excerpt}</p>
        <div className="mt-auto flex items-center gap-3 pt-2 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-newspaper-line" />
            {item.source}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}